<template>
  <v-container style="padding: 0;">
    <v-btn :disabled="loading || !selectedBudgets.length" color="success" depressed size="small" @click="getPDF()"
      :loading="loading">
      <v-icon left>mdi-printer</v-icon> CAPTAÇÃO
    </v-btn>
  </v-container>
</template>
<script>
import api from "@/http";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import UtilsPDF from '../../../service/utilsPDF';
import UtilsFunc from "../../../service/utilsFunc";
import logo from "../../../assets/logo.png";
import gptw from "../../../assets/GPTW_2023-2024.png";
import ona from "../../../assets/ONA_Nivel_3.png";

const { withCRUDUtils } = UtilsFunc
export default {
  name: "Domicilio",
  data: () => withCRUDUtils({
    loading: false,
    captacao: [],
    paciente: [],
    quandroclinico: [],
    assinaturas: [],
  }),
  props: {
    selectedBudgets: {
      type: Array,
      default: () => []
    },
    username: String
  },
  methods: {
    async getPDF() {
      this.loading = true;
      this.$toast.success(
        `O documento está sendo preparado. Isso pode levar alguns instantes. Aguarde, por favor.`
      );
      try {
        // Primeiro, carregue o orçamento e o endereço, depois a captação
        await this.getPaciente(); // Aguarde o carregamento do endereço
        await this.getQuadroClinico()
        await this.getCaptacao();
        
        // Certifique-se de que o PDF foi gerado antes de salvar
        await this.generatePDF();
        this.savePDF();
        this.loading = false;
      } catch (error) {
        this.$toast.error("Erro ao carregar os dados:", error);
        this.loading = false;
      }
    },
    drawHeader(doc) {
      const captacao = this.captacao[0]
      const paciente = this.paciente[0]
      const pageWidth = 210;
      // const yFixedPosition = 100;

      try {
        doc.addImage(logo, 10, 8, 28, 28);
        doc.addImage(ona, 160, 10, 15, 15);
        doc.addImage(gptw, 185, 10, 15, 15);
      } catch (error) {
        this.$toast.error("Falha ao adicionar a imagem ao PDF (L-61):", error);
      }
      doc.setFont("helvetica", "normal");
      doc.setDrawColor(57, 106, 159);
      doc.setLineWidth(1);
      doc.line(5, 5, 205, 5);

      // Ajustar a coordenada 'rectY' para mover o retângulo para cima
      doc.setLineWidth(0.5);
      const rectX = 3;
      const rectY = 40;  // Diminuir este valor para mover o retângulo para cima (era 40)
      const rectWidth = 204;
      const rectHeight = 72;  // Aumente este valor para aumentar a altura do retângulo
      const borderRadius = 2;
      doc.roundedRect(rectX, rectY, rectWidth, rectHeight, borderRadius, borderRadius, "S");

      doc.setDrawColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("São Luís Home Care", 105, 15, { align: "center" });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(16);
      doc.text(`CAPTAÇÃO`, 105, 23, { align: "center" });

      moment.locale("pt-br");

      const currentDate = new Date();
      const hour = moment(currentDate).format("HH:mm");
      const xFixedPosition = 10;
      const lineHeight = 6

      doc.setFontSize(8);
      if (this.username && this.username.trim()) {
        doc.text(`Gerado por: ${this.username}`, 200, 28, { align: "right"});
      }
      doc.text("Data e Hora da Impressão:", 200, 32, { align: "right" });
      doc.text(`${UtilsPDF.formatDate(currentDate)} às ${hour} - ${captacao?.id}/${captacao?.captacao.id}`, 200, 36, { align: "right", });
      doc.text(`FORM: 130`, 200, 39, { align: "right", });

      doc.setFontSize(11);
      const horaFormatada = captacao.hora_inicio ? `às ${captacao.hora_inicio.substring(0, 5)}` : ''; // Garante que sai apenas hh:mm
      doc.text(`Avaliado em: ${UtilsPDF.formatDate(captacao.timestamp)}  ${horaFormatada}`, 81, 32);

      let yPosition = 48  

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      const textWidth1 = doc.getTextWidth("DADOS DO PACIENTE");
      const xCenteredPosition1 = pageWidth / 2 - textWidth1 / 2;
      doc.text("DADOS DO PACIENTE", xCenteredPosition1, yPosition);

      yPosition += lineHeight + 2
      
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text( `Paciente: ${paciente.nome ?? ''}`, xFixedPosition, yPosition );
      
      const dataNascimento = this.selectedBudgets[0].data_nascimento 
                ? `Data Nascimento: ${UtilsPDF.formatDate(this.selectedBudgets[0].data_nascimento)}` 
                : 'Data Nascimento: ';
      
      doc.text( dataNascimento,  200,  yPosition,  { align: "right" } );
      
      doc.setFont("helvetica", "normal");
      yPosition += lineHeight
      doc.text(`CPF: ${paciente.cpf ? paciente.cpf : ''}  -  RG: ${paciente.rg ? paciente.rg : ''}  -  Sexo: ${paciente.sexo_biologico ? paciente.sexo_biologico : ''}  -  Peso: ${paciente.peso ? paciente.peso : ''}  -  Altura: ${paciente.altura ? paciente.altura : ''}`, xFixedPosition, yPosition);

      yPosition += lineHeight
      doc.text(`Endereço: ${paciente.endereco.logradouro ?? ''}, ${paciente.endereco.nr ?? ''}, ${paciente.endereco.bairro ?? ''}, ${paciente.endereco.cidade ?? ''} / ${paciente.endereco.estado ?? ''} - CEP:${paciente.endereco.cep ? paciente.endereco.cep : ''}`, xFixedPosition, yPosition);
     
      yPosition += lineHeight
      doc.text(`Referência:${paciente.endereco.referencia ? paciente.endereco.referencia : ''}`, xFixedPosition, yPosition);
      
      yPosition += lineHeight
      doc.text(`Responsável: ${paciente.responsavel ?? ''}      -      Telefone: ${paciente.telefone ?? ''}`, xFixedPosition, yPosition);

      yPosition += lineHeight
      doc.text(`Etnia: ${paciente.etinia ?? ''}      -    Religião: ${paciente.religiao ?? ''}      -      Profissão: ${paciente.profissao ?? ''}     -      Estado Civil: ${paciente.estado_civil ?? ''}`, xFixedPosition, yPosition);
      
      yPosition += lineHeight
      doc.text(`Local de Avaliação: ${captacao?.captacao.local.nome ? captacao.captacao.local.nome : ''}      -    Leito: ${captacao?.captacao.leito ? captacao.captacao.leito  : ''}`, xFixedPosition, yPosition);

      yPosition += lineHeight
      const operadora = this.selectedBudgets[0].operadora.nome || '';
            doc.text(`Operadora: ${operadora}`, xFixedPosition, yPosition);

      const nrCarteirinha = this.selectedBudgets[0].nr_carteirinha || '';
            doc.text(`Nº da Carteira: ${nrCarteirinha}`, 200, yPosition, { align: "right" });

      yPosition += lineHeight

      const cid = this.selectedBudgets[0].cid?.nome || '';

      if (cid && cid.length > 0) {
          const cidDescricao = this.selectedBudgets[0].cid.descricao || '';
          const fullText = `CID: ${cid} - ${cidDescricao}`;

          const splittedText = doc.splitTextToSize(fullText, rectWidth - 10);

          splittedText.forEach((line, i) => {
              doc.text(line, xFixedPosition, yPosition + (lineHeight * i));
          });

          yPosition += (lineHeight * splittedText.length);
      } else {
          doc.setFont("helvetica", "normal");
          doc.text(`CID: `, xFixedPosition, yPosition);
      }

      
      yPosition += lineHeight
      
      yPosition = 118
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      const textWidth = doc.getTextWidth("CAPTAÇÃO DO PACIENTE");
      const xCenteredPosition = pageWidth / 2 - textWidth / 2;
      doc.text("CAPTAÇÃO DO PACIENTE", xCenteredPosition, yPosition);
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");

    },
    async download(dataurl, filename) {
      const httpsurl = !dataurl.includes("https") ? dataurl.replace("http", "https") : dataurl
      const res = await fetch(httpsurl)
      const buffer = await res.blob()
      const url = URL.createObjectURL(buffer)
      const link = document.createElement("a");
      link.download = filename;
      link.href = url;
      link.click();
    },
    async savePDF() {
      const captacao = this.captacao[0]
      const paciente = this.paciente[0]
      const periodoOrcamento = `${UtilsPDF.formatDateToFilename(captacao.timestamp)}`;
      const filename = `CAPTACAO_${paciente.nome.replace(/\s+/g, '_')}_${this.selectedBudgets[0].operadora.nome.replace(/\s+/g, '_')}_Avaliado_em_ ${periodoOrcamento}.pdf`;

      await this.generatePDF();

      const pdfBuffer = this.doc.output('arraybuffer')
      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" })
      const formData = new FormData()
      formData.append("file", pdfBlob, filename)
      formData.append("filename", filename);
      const { data: signedForm } = await api.post('multi_empresas/sign-pdf/', formData)

       // Código para salbvar no doc do paciente 
      const addHttps = signedForm.path.replace('http://', 'https://')
      const signedPDFBlob = await fetch(addHttps).then(r => r.blob())
      await this.saveDocument(signedPDFBlob, filename);

      const signedPdfUrl = signedForm.path

      this.download(signedPdfUrl, filename)
      this.$toast.success('O download do relatório foi realizado com sucesso!');
    },
    // Fórmula para salvar automaticamente o doc nos docs do paciente
    async saveDocument(pdfBlob, filename) {
      const today = new Date().toISOString().split('T')[0];
      const formData = new FormData();
      formData.append("arquivo", pdfBlob, filename);
      formData.append("paciente", this.captacao[0].paciente.id);
      formData.append("tipodoc", 35);
      formData.append("tipopasta", 6);
      formData.append("data_carregado", today);
      try {
        await api.post('pacientes/docs/', formData);
        this.$toast.success('O relatório foi salvo nos documentos do paciente.');
      } catch (error) {
        this.$toast.error('Erro ao salvar o relatório nos documentos do paciente.', error);
      }
    },
    async generatePDF() {
      const doc = new jsPDF({ compress: true });
      this.drawHeader(doc);
      
      let yPosition = 121;
  
    // Definição da largura de 90% da página
      const fullWidth = 200;
      const startX = (210 - fullWidth) / 2; // Centraliza o retângulo horizontalmente
      let lineHeight = 5; // A altura da linha para o texto "GRUPO 1 – ELEGIBILIDADE"
      const pageWidth = doc.internal.pageSize.getWidth();

      const checkPageBreak = (doc, yPosition, additionalHeight = 0) => {
        const pageHeight = doc.internal.pageSize.height; // Altura da página
        const marginBottom = 20; // Espaço mínimo necessário no final da página

        if (yPosition + additionalHeight > pageHeight - marginBottom) {
            doc.addPage(); // Adiciona uma nova página
            // this.drawHeader(doc); // Redesenha o cabeçalho
                    try {
                      doc.addImage(logo, 10, 8, 28, 28);
                      doc.addImage(ona, 160, 10, 15, 15);
                      doc.addImage(gptw, 185, 10, 15, 15);
                    } catch (error) {
                      this.$toast.error("Falha ao adicionar a imagem ao PDF (L-61):", error);
                    }
                    doc.setFont("helvetica", "normal");
                    doc.setDrawColor(57, 106, 159);
                    doc.setLineWidth(1);
                    doc.line(5, 5, 205, 5);

                    doc.setDrawColor(0, 0, 0);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(18);
                    doc.text("São Luís Home Care", 105, 15, { align: "center" });
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(16);
                    doc.text(`CAPTAÇÃO`, 105, 23, { align: "center" });

                    moment.locale("pt-br");

                    const currentDate = new Date();
                    const hour = moment(currentDate).format("HH:mm");
                    const lineHeight = 6

                    doc.setFontSize(8);
                    doc.text(`Gerado por: ${this.username}`, 200, 28, { align: "right"});
                    doc.text("Data e Hora da Impressão:", 200, 32, { align: "right" });
                    doc.text(`${UtilsPDF.formatDate(currentDate)} às ${hour}`, 200, 36, { align: "right", });
                    doc.text(`FORM: 130`, 200, 39, { align: "right", });
            yPosition += lineHeight
    
            return 42; // Retorna a nova posição Y no topo da página seguinte
        }
        return yPosition;
    };

      // Exemplo de uso da verificação de quebra de página antes de desenhar elementos
      // yPosition = checkPageBreak(doc, yPosition, lineHeight);

      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

//RESUMO DO QUADRO CLÍNICO
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth8 = doc.getTextWidth("RESUMO DO QUADRO CLÍNICO");
      // const textXPosition8 = startX + (fullWidth / 2) - (textWidth8 / 2);
      // doc.text("RESUMO DO QUADRO CLÍNICO", textXPosition8, yPosition + lineHeight / 2 + 1);
      doc.text("RESUMO DO QUADRO CLÍNICO:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let quadroclinico = this.captacao[0]?.captacao?.quadro_clinico_inicial
 
      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (quadroclinico) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(quadroclinico, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight; 
          yPosition = checkPageBreak(doc, yPosition, lineHeight); // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
        yPosition += lineHeight;
      }
       yPosition += lineHeight;
       yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);


//PLANO TERAPÊUTICO
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth = doc.getTextWidth("PLANO TERAPÊUTICO");
      // const textXPosition = startX + (fullWidth / 2) - (textWidth / 2);
      // doc.text("PLANO TERAPÊUTICO", textXPosition, yPosition + lineHeight / 2 + 1);  // Ajuste a posição Y para centralizar verticalmente
      doc.text("PLANO TERAPÊUTICO:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      // Constrói a string do plano terapêutico
      let planoTerapeutico = [];

      if (this.captacao[0]?.captacao?.medica) {
          planoTerapeutico.push(`Visita Médica ${this.captacao[0]?.captacao?.medica.nome}`);
      }
      if (this.captacao[0]?.captacao?.enfermeira) {
          planoTerapeutico.push(`Visita de Enfermeira ${this.captacao[0]?.captacao?.enfermeira.nome}`);
      }
      if (this.captacao[0]?.captacao?.nutricionista) {
          planoTerapeutico.push(`Visita de Nutricionista ${this.captacao[0]?.captacao?.nutricionista.nome}`);
      }
      if (this.captacao[0]?.captacao?.assistente_social) {
          planoTerapeutico.push(`Visita de Assistente Social ${this.captacao[0]?.captacao?.assistente_social.nome}`);
      }
      if (this.captacao[0]?.captacao?.fisioterapia) {
          planoTerapeutico.push(`Visita de Fisioterapia ${this.captacao[0]?.captacao?.fisioterapia.nome}`);
      }
      if (this.captacao[0]?.captacao?.fonoaudiologia) {
          planoTerapeutico.push(`Visita de Fonoaudiologia ${this.captacao[0]?.captacao?.fonoaudiologia.nome}`);
      }
      if (this.captacao[0]?.captacao?.terapia_ocupacional) {
          planoTerapeutico.push(`Visita de Terapia Ocupacional ${this.captacao[0]?.captacao?.terapia_ocupacional.nome}`);
      }
      if (this.captacao[0]?.captacao?.psicologia) {
          planoTerapeutico.push(`Visita de Psicologia ${this.captacao[0]?.captacao?.psicologia.nome}`);
      }

      // Junta todos os textos em uma única string
      const planoTerapeuticoText = planoTerapeutico.join(', ');

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (planoTerapeuticoText) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(planoTerapeuticoText, fullWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }
    
      yPosition += lineHeight ;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// DOENÇAS PRÉ-EXISTENTES
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth1 = doc.getTextWidth("DOENÇAS PRÉ-EXISTENTES");
      // const textXPosition1 = startX + (fullWidth / 2) - (textWidth1 / 2);
      // doc.text("DOENÇAS PRÉ-EXISTENTES", textXPosition1, yPosition + lineHeight / 2 + 1); // Ajuste a posição Y para centralizar verticalmente
      doc.text("DOENÇAS PRÉ-EXISTENTES:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      
      yPosition += lineHeight;

      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let doencas = this.captacao[0]?.captacao?.doenca_existente?.map(doenca => doenca.nome).join(', ');

      // Adiciona o conteúdo da variável 'outras_doencas' se houver dados
      const outrasDoencas = this.captacao[0]?.captacao?.outras_doencas;
      if (outrasDoencas) {
        doencas = doencas ? `${doencas}, ${outrasDoencas}` : outrasDoencas;
      }

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (doencas) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(doencas, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// ASSISTÊNCIA TERAPÊUTICA
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth2 = doc.getTextWidth("ASSISTÊNCIA TERAPÊUTICA");
      // const textXPosition2 = startX + (fullWidth / 2) - (textWidth2 / 2);
      // doc.text("ASSISTÊNCIA TERAPÊUTICA", textXPosition2, yPosition + lineHeight / 2 + 1);  // Ajuste a posição Y para centralizar verticalmente
      doc.text("ASSISTÊNCIA TERAPÊUTICA:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let assistencia = this.captacao[0]?.captacao?.assistencia_terapeutica?.map(doenca => doenca.nome).join(', ');
      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (assistencia) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(assistencia, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// TERAPIA VENOSA
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth3 = doc.getTextWidth("TERAPIA VENOSA");
      // const textXPosition3 = startX + (fullWidth / 2) - (textWidth3 / 2);
      // doc.text("TERAPIA VENOSA", textXPosition3, yPosition + lineHeight / 2 + 1);
      doc.text("TERAPIA VENOSA:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5
      
      
      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let terapiaVenosa = this.captacao[0]?.captacao?.terapia_venosa || [];
      // Monta a string final incluindo as informações adicionais
      let terapiaVenosaText = terapiaVenosa.map(item => {
          let texto = item.nome;
          if (item.id === 1) { // Antibioticoterapia
              texto += `: ${this.captacao[0]?.captacao?.antibiotico || ''}`;
          } else if (item.id === 2) { // Anticoagulante
              texto += `: ${this.captacao[0]?.captacao?.anticoagulante || ''}`;
          } else if (item.id === 5) { // Hemoderivados
              texto += `: ${this.captacao[0]?.captacao?.hemoderivado || ''}`;
          }
          return texto;
      }).join(', ');

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (terapiaVenosaText) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(terapiaVenosaText, fullWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }
      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// SUPORTE NUTRICIONAL
      // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth4 = doc.getTextWidth("SUPORTE NUTRICIONAL");
      // const textXPosition4 = startX + (fullWidth / 2) - (textWidth4 / 2);
      // doc.text("SUPORTE NUTRICIONAL", textXPosition4, yPosition + lineHeight / 2 + 1);
      doc.text("SUPORTE NUTRICIONAL:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5

      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let nutricao = this.captacao[0]?.captacao?.suporte_nutricional?.map(doenca => {
        if (doenca.nome === 'Gastrostomia') {
          const nrSonda = this.captacao[0]?.captacao?.nr_sonda_gastrostomia;
          return nrSonda ? `Gastrostomia nº ${nrSonda}` : 'Gastrostomia';
        }
        return doenca.nome;
      }).join(', ');
      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (nutricao) {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        
        // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
        const splittedText = doc.splitTextToSize(nutricao, fullWidth - 10);
        // Calcula a altura total necessária para o retângulo com base no número de linhas
        const dynamicHeight = lineHeight * splittedText.length;

        // Desenha o retângulo ajustado à altura necessária
        doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');
        
        // Renderiza o texto quebrado linha por linha
        splittedText.forEach(line => {
          doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
          yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
        });
      } else {
        doc.setTextColor(0, 0, 0);  // Texto preto
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// MONITORIZAÇÃO DE SINTOMAS
       // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth5 = doc.getTextWidth("MONITORIZAÇÃO DE SINTOMAS");
      // const textXPosition5 = startX + (fullWidth / 2) - (textWidth5 / 2);
      // doc.text("MONITORIZAÇÃO DE SINTOMAS", textXPosition5, yPosition + lineHeight / 2 + 1);
      doc.text("MONITORIZAÇÃO DE SINTOMAS:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5
      
      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let monitorizacao = this.captacao[0]?.captacao?.monitorizacao || [];

      // Monta a string final incluindo as informações adicionais
      let monitorizacaoText = monitorizacao.map(item => item.nome).join(', ');

      // Verifica se há pelo menos um item em `monitorizacao`
      if (monitorizacao.length > 0) {
          // Inclui a frase ao final, apenas uma vez
          monitorizacaoText += ` ${this.captacao[0]?.captacao?.glicemia || ''} `;
      } else {
        monitorizacaoText = "Sem Monitorização";
      }

      // Agora você pode usar `monitorizacaoText` conforme necessário


      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (terapiaVenosaText) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(monitorizacaoText, fullWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }
      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// MÉTODO DIALÍTICO
       // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth6 = doc.getTextWidth("MÉTODO DIALÍTICO");
      // const textXPosition6 = startX + (fullWidth / 2) - (textWidth6 / 2);
      // doc.text("MÉTODO DIALÍTICO", textXPosition6, yPosition + lineHeight / 2 + 1);
      doc.text("MÉTODO DIALÍTICO:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5
      
      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let dialise = this.captacao[0]?.captacao?.dialise || [];
      // Monta a string final incluindo as informações adicionais
      let dialiseText = dialise.map(item => {
          let texto = item.nome;
          if (item.id === 1) { // Hemodiálise"
              texto += `: ${this.captacao[0]?.captacao?.hemodialise || ''} `;
          } else if (item.id === 2) { // Diálise Peritoneal"
              texto += `: ${this.captacao[0]?.captacao?.peritoneal || ''}`;
          } 
          return texto;
      }).join(', ');

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (terapiaVenosaText) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(dialiseText, fullWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }
      yPosition += lineHeight;
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// PROCEDIMENTOS INVASIVOS
       // Desenha o retângulo com 90% da largura da página
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // const textWidth7 = doc.getTextWidth("PROCEDIMENTOS INVASIVOS");
      // const textXPosition7 = startX + (fullWidth / 2) - (textWidth7 / 2);
      // doc.text("PROCEDIMENTOS INVASIVOS", textXPosition7, yPosition + lineHeight / 2 + 1);
      doc.text("PROCEDIMENTOS INVASIVOS:", startX + 5, yPosition + lineHeight / 2 + 1); // Adiciona um pequeno espaçamento à esquerda com +5
      
      yPosition += lineHeight ;
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Branco para o fundo
      doc.rect(startX, yPosition, fullWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      let procedimento_invasivo = this.captacao[0]?.captacao?.procedimento_invasivo || [];
      // Monta a string final incluindo as informações adicionais
      let procedimento_invasivoText = procedimento_invasivo.map(item => {
          let texto = item.nome;
          if (item.id === 4) { // Cateter Periférico"
              texto += ` nº ${this.captacao[0]?.captacao?.n_cateter || ''}`;
          } else if (item.id === 5) { // Sonda Vesical de Demora"
              texto += ` nº ${this.captacao[0]?.captacao?.sonda_demora || ''}`; 
          } else if (item.id === 6) { // Sonda Vesical de Demora"
              texto += ` nº ${this.captacao[0]?.captacao?.tipo_n_traqueostomia || ''}`;
          } else if (item.id === 9) { // Aspirações"
              texto += ` ${this.captacao[0]?.captacao?.quant_aspiracao || ''} `;
          } 
          return texto;
      }).join(', ');

      // Verifica se há dados para mostrar; se não, exibe "Sem Relatos"
      if (terapiaVenosaText) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedText = doc.splitTextToSize(procedimento_invasivoText, fullWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          const dynamicHeight = lineHeight * splittedText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(startX, yPosition, fullWidth, dynamicHeight, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedText.forEach(line => {
              doc.text(line, startX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", startX + 5, yPosition + lineHeight / 2 + 1);
      }

      // Verifique se há espaço suficiente para a imagem (100) + altura do texto (assuma uns 40px mínimo)
      const alturaNecessaria = 100 + (lineHeight * 2);
      yPosition = checkPageBreak(doc, yPosition, alturaNecessaria);

      
// LESÕES E IMAGEM
      // Definindo as larguras e posições
      const lesoesWidth = pageWidth / 2 - 10;  // 50% da largura da página com margem
      const imageWidth = lesoesWidth;  // Mesma largura do campo "Lesões"
      const imageStartX = startX;  // Posição inicial no lado esquerdo
      const lesoesStartX = imageStartX + imageWidth + 10;  // Posição inicial no lado direito, ao lado da imagem

      // Fixando a altura da imagem em 100
      const fixedImageHeight = 100;

      // Renderiza a imagem no lado esquerdo
      let arquivo = this.captacao[0].captacao.arquivo;
      if (arquivo) {
          let imageUrl = arquivo;
          const params = arquivo.split('://');
          if (params[0] === 'http' && params[1] !== 'localhost') {
              imageUrl = imageUrl.replace('http', 'https');
          }
          try {
              // Adiciona a imagem com a altura fixa
              doc.addImage(imageUrl, 'JPEG', imageStartX, yPosition, imageWidth, fixedImageHeight);
          } catch (error) {
              doc.setTextColor(0, 0, 0);  // Texto preto
              doc.setFont("helvetica", "normal");
              doc.setFontSize(10);
              doc.text("Falha ao carregar a imagem", imageStartX + 5, yPosition + lineHeight / 2 + 1);
          }
      }

      // Desenha o retângulo com 50% da largura da página para "LESÕES" no lado direito
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(57, 106, 159);  // Azul para o fundo
      doc.rect(lesoesStartX, yPosition, lesoesWidth, lineHeight, 'FD'); // 'FD' desenha e preenche o retângulo

      doc.setTextColor(255, 255, 255);  // Texto branco
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("LESÕES:", lesoesStartX + 5, yPosition + lineHeight / 2 + 1);  // Texto "LESÕES" alinhado à esquerda do retângulo

      // Espaçamento entre o título e o conteúdo de "LESÕES"
      yPosition += lineHeight;

      // Desenha o retângulo padrão abaixo do título "LESÕES"
      doc.setDrawColor(0, 0, 0);  // Cor preta para as bordas
      doc.setFillColor(255, 255, 255);  // Fundo branco
      doc.rect(lesoesStartX, yPosition, lesoesWidth, lineHeight, 'FD'); // Desenha o retângulo

      let lesoes = this.captacao[0].captacao.lesoes;
      // Verifica se há dados para mostrar na variável lesoes; se não, exibe "Sem Relatos"
      let dynamicHeightLesoes = lineHeight;
      if (lesoes) {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          // Quebra o texto em várias linhas, se necessário, com base na largura do retângulo
          const splittedLesoesText = doc.splitTextToSize(lesoes, lesoesWidth - 10);
          // Calcula a altura total necessária para o retângulo com base no número de linhas
          dynamicHeightLesoes = lineHeight * splittedLesoesText.length;

          // Desenha o retângulo ajustado à altura necessária
          doc.rect(lesoesStartX, yPosition, lesoesWidth, dynamicHeightLesoes, 'FD');

          // Renderiza o texto quebrado linha por linha
          splittedLesoesText.forEach(line => {
              doc.text(line, lesoesStartX + 5, yPosition + lineHeight / 2 + 1);
              yPosition += lineHeight;  // Ajusta a posição vertical para a próxima linha
          });
      } else {
          doc.setTextColor(0, 0, 0);  // Texto preto
          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.text("Sem Relatos", lesoesStartX + 5, yPosition + lineHeight / 2 + 1);
      }

      // Ajuste yPosition conforme necessário após renderizar a imagem e lesões
      yPosition += Math.max(dynamicHeightLesoes, fixedImageHeight) + 10;  // Espaçamento adicional após a imagem e lesões

      // Verificação de quebra de página antes de continuar com o carimbo do profissional
      yPosition = checkPageBreak(doc, yPosition, lineHeight * 2);

// Carimbo do Profissional
      const profissional = this.captacao[0].profissional;
      const especialidade = this.captacao[0].especialidade;
      
      if (profissional) {
          const xCarimboPosition = pageWidth - 40;  // Posição X para a imagem e texto do carimbo
          let carimboImageURL = profissional.carimbo;
          const params = profissional.carimbo.split('://')
            if (params[0] === 'http' && params[1] !== 'localhost') {
              carimboImageURL = carimboImageURL.replace('http', 'https')
            }

          if (carimboImageURL) {
              // Adiciona a imagem do carimbo se disponível
              doc.addImage(carimboImageURL, 'JPEG', xCarimboPosition, yPosition +2, 25, 10); // Tamanho e posição ajustados
          }
          // Adiciona o nome do profissional abaixo da imagem do carimbo
          doc.setFontSize(8);
          doc.text(`${profissional.apelido} - ${especialidade.nome}`, xCarimboPosition + 12, yPosition + 18, { align: 'center' });
      }


      yPosition = checkPageBreak(doc, yPosition, lineHeight  / 2 + 1);
      UtilsPDF.addPageNumbers(doc);
      this.doc = doc;
    },
    async getCaptacao() {
      try {
        const { data } = await api.get(`atendimentos/app-evolucoes-nead_abemid/?paciente_id=${this.selectedBudgets[0].id}&captacao=true`);
        this.captacao = data;
        const casaDataWithValues = data.filter(item => item.captacao && Object.keys(item.captacao).length > 0);
        if (casaDataWithValues.length > 0) {
          const latestcasaData = casaDataWithValues.reduce((latest, current) => {
            return new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest;
          });
          this.captacao = [latestcasaData];
          // console.log('captacao -> ', this.captacao)
        } else {
          this.captacao[0] = null;
          // console.log('captacao -> ', this.captacao)
        }
      } catch (error) {
        // this.$toast.error("Erro ao buscar os dados do captacao:", error);
      } 
    },
    async getPaciente() {
      try {
        const { data } = await api.get(`pacientes/detalhes/?paciente=${this.selectedBudgets[0].id}`);
        this.paciente = data;
        // console.log('Endereço endpoint', this.paciente)
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados do Endereço:", error);
      }
    },
    async getQuadroClinico() {
      try {
        const { data } = await api.get(`atendimentos/app-texto-quadroclinico/?paciente=${this.selectedBudgets[0].id}`);
          this.quadroclinico = data[0]
          // console.log('getQuadroClinico -> ', this.quadroclinico)
      } catch (error) {
        this.$toast.error("Erro ao buscar os dados da Quadro Clínico :", error);
      }
    },
  },
};
</script>